export default class List {
    constructor(r) {
        this.item = {};
        if(r != false) {
            this.item = r;
        }

        this.defaults();
    }

    isset(key) {
        if(typeof this.item[key] === 'undefined') {
            return false;
        }

        return true;
    }

    output() {
        return this.item;
    }

    defaults() {


        if(!this.isset('align')) {
            this.item.align = 'left';
        }

        if(!this.isset('font')) {
            this.item.font = 'inherit';
        }

        if(!this.isset('size')) {
            this.item.size = 'inherit';
        }

        if(!this.isset('color')) {
            this.item.color = 'inherit';
        }

        if(!this.isset('line1_text')) {
            this.item.line1_text = 'Item 1';
        }
        if(!this.isset('line1_link')) {
            this.item.line1_link = '';
        }

        if(!this.isset('line2_text')) {
            this.item.line2_text = 'Item 2';
        }
        if(!this.isset('line2_link')) {
            this.item.line2_link = '';
        }

        if(!this.isset('line3_text')) {
            this.item.line3_text = '';
        }
        if(!this.isset('line3_link')) {
            this.item.line3_link = '';
        }

        if(!this.isset('line4_text')) {
            this.item.line4_text = '';
        }
        if(!this.isset('line4_link')) {
            this.item.line4_link = '';
        }

        if(!this.isset('line5_text')) {
            this.item.line5_text = '';
        }
        if(!this.isset('line5_link')) {
            this.item.line5_link = '';
        }

        if(!this.isset('id')) {
            this.item.id = false;
        }

    }
}


// WEBPACK FOOTER //
// ./helpers/list.js